import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../ThemeProvider";

const Home = () => {
  const { isDarkTheme } = useContext(ThemeContext);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const toggleAnimation = () => {
      setIsActive((prev) => !prev);
    };

    // Start animation immediately
    toggleAnimation();

    const animationDuration = 4400; // Adjust this to match your total animation time
    const intervalId = setInterval(toggleAnimation, animationDuration);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="home">
      <svg
        className={isActive ? "active" : ""}
        width="40vh"
        // height="100%"
        viewBox="0 0 716 906"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M437.287 383.898L470.794 361.553C475.292 358.554 481.282 359.147 485.104 362.97V362.97C489.19 367.055 495.695 367.416 500.207 363.806L522.859 345.685C525.356 343.687 528.295 342.317 531.431 341.69L549.329 338.111C556.413 336.694 563.652 339.692 567.66 345.703V345.703C571.916 352.088 579.781 355.033 587.185 353.014L648.774 336.217C649.428 336.039 649.994 336.704 649.713 337.32L620.111 402.445C617.663 407.831 618.812 414.172 622.996 418.355V418.355C627.1 422.46 628.292 428.649 626.006 433.984L611.14 468.672C609.843 471.697 607.821 474.355 605.251 476.411L579.003 497.409C576.754 499.208 576.569 502.562 578.605 504.599V504.599C580.346 506.34 580.5 509.111 578.961 511.034L557.851 537.422C555.442 540.433 552.215 542.683 548.558 543.902L499.111 560.384C495.507 561.586 493.802 565.702 495.501 569.1V569.1C497.342 572.783 495.178 577.208 491.141 578.015L468.374 582.569C465.997 583.044 463.554 583.083 461.164 582.685L423.528 576.412"
          stroke={isDarkTheme ? "white" : "black"}
          stroke-linecap="round"
          class="svg-elem-1"
        ></path>
        <path
          d="M423.523 528.283L472.949 454.148C476.612 448.653 481.579 444.151 487.406 441.043L581.662 390.773"
          stroke={isDarkTheme ? "white" : "black"}
          stroke-linecap="round"
          class="svg-elem-2"
        ></path>
        <path
          d="M292.954 905.117L413.619 766.902C423.878 755.151 428.065 739.285 424.939 724.002L394.564 575.461C394.057 572.983 393.363 570.546 392.487 568.173L376.336 524.393"
          stroke={isDarkTheme ? "white" : "black"}
          stroke-linecap="round"
          class="svg-elem-3"
        ></path>
        <path
          d="M141.632 583.288L214.284 642.731C216.265 644.351 218.397 645.778 220.65 646.991L306.644 693.296M289.801 739.797L337.858 719.126C345.199 715.968 349.956 708.744 349.956 700.753L349.956 674.283C349.956 673.209 349.869 672.137 349.697 671.077L343.362 632.076C342.266 625.329 334.562 621.972 328.874 625.764V625.764C324.306 628.809 318.112 627.307 315.446 622.509L287.626 572.432C286.565 570.523 285.115 568.86 283.368 567.55L268.486 556.387C264.379 553.306 258.517 556.237 258.517 561.371V561.371C258.517 566.922 251.807 569.701 247.882 565.777L215.24 533.135C212.096 529.99 207.992 527.983 203.579 527.432L165.106 522.623C159.454 521.916 154.09 525.297 152.288 530.7V530.7C150.201 536.96 143.433 540.343 137.173 538.256L67.7477 515.112C67.085 514.891 66.4774 515.566 66.7664 516.202L96.4348 581.485C98.8071 586.705 97.6928 592.849 93.6384 596.903V596.903C89.4516 601.09 88.4137 607.486 91.0616 612.782L105.803 642.264C106.764 644.187 108.029 645.942 109.549 647.462L129.009 666.922C131.836 669.75 131.063 674.516 127.487 676.304V676.304C124.151 677.972 123.202 682.291 125.532 685.203L144.29 708.651C147.026 712.07 150.808 714.498 155.057 715.56L197.147 726.082C201.187 727.092 204.583 729.817 206.445 733.54V733.54C208.862 738.372 213.801 741.424 219.203 741.424L281.898 741.424C284.616 741.424 287.305 740.871 289.801 739.797Z"
          stroke={isDarkTheme ? "white" : "black"}
          stroke-linecap="round"
          class="svg-elem-4"
        ></path>
        <path
          d="M258.495 480.157L306.711 498.236C311.202 499.92 315.959 500.783 320.754 500.783L337.043 500.783C339.677 500.783 342.305 500.522 344.888 500.006L363.505 496.282C371.249 494.734 378.36 490.928 383.944 485.344L390.202 479.086C394.033 475.256 397.045 470.687 399.057 465.657L406.898 446.055C408.788 441.33 409.759 436.288 409.759 431.2L409.759 405.274C409.759 404.774 409.722 404.276 409.647 403.781L405.106 373.702M141.607 377.022L141.616 399.842C141.618 402.809 142.936 405.621 145.215 407.52L180.625 437.026C182.096 438.252 183.887 439.029 185.786 439.267L234.866 445.402C236.824 445.647 238.812 445.307 240.577 444.424L277.682 425.876C278.644 425.395 279.522 424.762 280.282 424.002L296.318 407.961L313.502 390.773L346.058 358.226C347.259 357.025 348.747 356.15 350.38 355.683L396.008 342.644L429.169 329.383C429.984 329.057 430.753 328.625 431.456 328.098L455.401 310.139C457.028 308.919 458.244 307.231 458.887 305.302L470.492 270.487C471.24 268.243 471.169 265.807 470.29 263.611L458.391 233.863C458.065 233.047 457.633 232.279 457.106 231.577L437.932 206.011C437.494 205.427 436.993 204.893 436.439 204.418L389.137 163.882M217.254 404.524L204.492 378.987C203.845 377.692 202.925 376.553 201.794 375.649L170.945 350.969C169.752 350.015 168.358 349.347 166.867 349.016L108.045 335.944C107.518 335.827 107.001 335.668 106.5 335.467L75.4781 323.058C73.7758 322.377 72.2934 321.242 71.193 319.775L54.2445 297.184C52.9446 295.452 52.2424 293.344 52.2435 291.178L52.2473 283.789C52.2483 281.817 52.8326 279.889 53.9268 278.247L65.4507 260.961C65.8159 260.414 66.2343 259.903 66.6999 259.438L98.3185 227.817C99.6632 226.472 100.597 224.772 101.009 222.916L113.723 165.705C113.991 164.5 114.48 163.355 115.164 162.328L125.733 146.471C127.113 144.401 129.215 142.92 131.628 142.316L209.107 122.945C209.956 122.733 210.773 122.41 211.538 121.985L268.42 90.3863C270.87 89.025 273.779 88.7548 276.438 89.6413L288.958 93.8153C291.474 94.6542 293.554 96.4584 294.74 98.831L306.633 122.625M327.264 88.25L360.676 81.5686C361.322 81.4395 361.978 81.3745 362.637 81.3745L378.131 81.3745C380.783 81.3745 383.327 82.428 385.202 84.3034L401.752 100.854C402.512 101.614 403.145 102.491 403.626 103.452L415.16 126.522C416.128 128.457 417.697 130.026 419.632 130.994L440.448 141.402C442.82 142.588 444.624 144.668 445.463 147.184L451.028 163.881"
          stroke={isDarkTheme ? "white" : "black"}
          stroke-linecap="round"
          class="svg-elem-5"
        ></path>
        <path
          d="M331.141 309.334L331.141 340.323M308.723 291.194L251.28 345.614L251.28 357.455M261.352 235.011L289.379 284.381L254.55 320.419M353.819 211.208L324.759 211.208L305.538 186.23L286.047 186.23M318.291 178.745L301.663 163.881L254.55 163.881L242.457 176.73M199.761 168.052L226.445 141.821L268.916 141.821M172.306 186.439L172.723 171.328L187.153 159.881M293.856 245.341L357.093 245.341L375.699 265.615M344.491 223.589L303.469 223.589L293.347 208.557L275.963 208.557L269.161 220.651M240.696 296.233L239.941 312.105L213.614 340.323M243.229 263.776L202.849 302.231L203.146 318.874M194.341 283.372L183.337 283.372L173.38 269.739M352.808 318.874L352.808 289.431L339.707 274.566L313.757 274.566"
          stroke={isDarkTheme ? "white" : "black"}
          stroke-width="1.5"
          stroke-linecap="round"
          class="svg-elem-6"
        ></path>
        <path
          d="M161.354 196.465L179.732 196.465L161.354 208.748L161.354 196.465Z"
          fill={isDarkTheme ? "white" : "black"}
          class="svg-elem-7"
        ></path>
        <path
          d="M228.602 194.449L215.753 207.55L191.566 207.55L204.415 194.449L216.508 194.449L228.602 194.449Z"
          fill={isDarkTheme ? "white" : "black"}
          class="svg-elem-8"
        ></path>
        <path
          d="M157.309 252.144L163.356 247.609L163.101 236.775L153.879 224.682L180.737 224.682L169.4 236.775L169.402 247.104L195.856 259.953L211.476 255.67L201.147 268.267L171.418 257.938L169.403 259.702L161.844 267.26L157.309 252.144Z"
          fill={isDarkTheme ? "white" : "black"}
          class="svg-elem-9"
        ></path>
        <path
          d="M169.4 236.775L169.403 247.609M169.4 236.775L180.737 224.682L153.879 224.682L163.101 236.775L163.356 247.609L157.309 252.144L161.844 267.26L169.403 259.702L171.418 257.938L201.147 268.267L211.476 255.67L195.856 259.953L169.402 247.104L169.4 236.775ZM161.354 196.465L179.732 196.465L161.354 208.748L161.354 196.465ZM204.415 194.449L191.566 207.55L215.753 207.55L228.602 194.449L216.508 194.449L204.415 194.449Z"
          stroke={isDarkTheme ? "white" : "black"}
          stroke-width="3"
          stroke-linecap="round"
          class="svg-elem-10"
        ></path>
      </svg>

      <h1>Matteo Rosoli</h1>

      <h2>
        {" "}
        CEO & Co-Founder of{" "}
        <a
          href="https://newsrooms.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="headerLink"
        >
          newsrooms
        </a>
      </h2>
    </div>
  );
};

export default Home;
